"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeatmapTooltipAxesValue = void 0;
var _styles = require("@mui/material/styles");
/**
 * @ignore - internal component.
 */
const HeatmapTooltipAxesValue = exports.HeatmapTooltipAxesValue = (0, _styles.styled)('caption', {
  name: 'MuiChartsHeatmapTooltip',
  slot: 'AxesValue'
})(({
  theme
}) => ({
  textAlign: 'start',
  whiteSpace: 'nowrap',
  padding: theme.spacing(0.5, 1.5),
  color: (theme.vars || theme).palette.text.secondary,
  borderBottom: `solid ${(theme.vars || theme).palette.divider} 1px`,
  [`& span`]: {
    marginRight: theme.spacing(1.5)
  }
}));